<template>
  <div>
    <Modal :loading="loading" v-model="showModel" :width="800" :title="title" @on-ok="save" :footer-hide="disabled"
      @on-cancel="closeModel">
      <div class="form-area">
        <Form :disabled="disabled" style="width: 800px" :model="model" :label-width="120" label-position="right"
          :rules='rules' ref="form" inline>
          <FormItem :class="{ 'model-hidden': true }" label="文本框">
            <Input v-model="model.id" type="text"></Input>
          </FormItem>
          <Row>
            <Col span="12">
            <FormItem label="活动名称:" prop="name">
              <Input v-model="model.name" style="width:200px" type="text" :maxlength="50" />
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="所属地区:" prop="area">
              <Select v-model="model.area" style="width:200px" clearable>
                <Option v-for="(value, key) of areas" :value="value" :key="key">{{ value }}</Option>
              </Select>
            </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
            <FormItem label="活动地址:" prop="address">
              <Input v-model="model.address" style="width:200px" type="text" :maxlength="50" />
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="活动对象:" prop="target">
              <Input v-model="model.target" style="width:200px" type="text" :maxlength="50" />
            </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
            <FormItem label="活动时间:" prop="chooseDate">
              <DatePicker v-model="model.chooseDate" type="daterange" format="yyyy-MM-dd" placement="bottom-end"
                style="width: 250px" />
            </FormItem>
            </Col>
          </Row>

          <Row>
            <FormItem label="活动简介:" prop="desc">
              <Input v-model="model.desc" style="width:585px" type="textarea" :maxlength="500" show-word-limit />
            </FormItem>
          </Row>
          <Row>
            <FormItem label="上传图片:" prop="pic">
              <upload v-if="!disabled" :action="uploadUrl" :headers="headers" :limit="1" :file-list="model.picList"
                list-type="picture-card" :before-upload="beforeAvatarUpload" :on-success="handleSuccess"
                :on-remove="handleRemove" :on-exceed="handleExceed">
                <i class="el-icon-plus"></i>
              </upload>
              <img v-else :src="model.pic" alt="" style="width:100px;height:100px">
              <!--              <span style="font-size:10px ; color: red">建议图片680*290</span>-->
            </FormItem>
          </Row>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import util from '@/libs/util.js';
import upload from '@/components/upload'

export default {
  name: 'editItem',
  components: { upload },
  props: {
    title: {
      type: String,
      required: true
    },
    areas: {
      type: Object
    }
  },
  data() {
    return {
      uploadUrl: util.baseUrl + "api/common/upload",
      //ID
      id: null,
      loading: true,
      showModel: false,
      picList: [],
      //表单参数
      model: {
        id: null,
        name: null,
        area: null,
        startTime: null,
        endTime: null,
        address: null,
        target: null,
        desc: null,
        pic: null,
        chooseDate: [],
        picList: []
      },
      rules: {
        name: [{ required: true, message: '活动名称', trigger: 'blur' }],
        area: [{ required: true, message: '所属地区', trigger: 'change' }],
        chooseDate: [{
          type: 'array', required: true, message: '产品活动时间',
          fields: {
            0: { type: 'date', required: true, message: '产品活动时间', trigger: 'change' },
            1: { type: 'date', required: true, message: '产品活动时间', trigger: 'change' }
          }
        }],
        address: [{ required: true, message: '活动地址', trigger: 'blur' }],
        target: [{ required: true, message: '活动对象', trigger: 'blur' }],
        desc: [{ required: true, message: '活动简介', trigger: 'blur' },
        { max: 1000, message: '不能超过1000字', trigger: 'blur' }],
        pic: [{ required: true, message: '活动图片', trigger: 'change' }],
      },
      disabled: false,
      headers: {
        Authorization: localStorage.token,
      },
    };
  },
  mounted() {
  },
  methods: {
    handleSuccess(response, file, fileList) {
      if (response.success) {
        this.$set(this.model, 'pic', response.result.realPath || '')
        this.picList = fileList
        // this.$nextTick(() => {
        //   this.$refs.form.validateField('pic', res => {
        //     console.log(res, 'pic')
        //   })
        // })

      }

    },
    handleRemove(file, fileList) {
      this.model.pic = ''
    },
    handleExceed(file, fileList) {
      this.$message.error('只能上传一张图片')
    },
    //验证是否为图片
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },

    save() {
      let _this = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.model.startTime = this.model.chooseDate[0]
          this.model.endTime = this.model.chooseDate[1]
          console.log(this.model, '')
          util.http.post("/api/finance/activity/save", this.model)
            .then(function (response) {
              if (response.data.code === 200) {
                _this.$Notice.success({
                  title: '保存成功!'
                });
                _this.$parent.handleOk()
                _this.closeModel()
              } else {
                _this.$Notice.success({
                  title: response.data.message
                });
                _this.loding = false;
                _this.$nextTick(() => {
                  _this.loading = true;
                });
              }
            })
        } else {
          _this.loading = false;
          _this.$nextTick(() => {
            _this.loading = true;
          });
        }
      })
    },

    openModel() {
      console.log("232323")
      this.$refs.form.resetFields()
      this.showModel = true
    },
    closeModel() {
      this.model = {
        id: null,
        name: null,
        area: null,
        startTime: null,
        endTime: null,
        address: null,
        target: null,
        desc: null,
        picList: [],
        chooseDate: [],
        pic:''
      }
      this.$refs.form.resetFields()
      this.loading = true
      this.showModel = false
    },

  }
};
</script>

<style scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}

.button-right-left {
  margin-right: 15px;
}

.button-right {
  margin-right: 55px;
}

.form-area {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.form-flex {
  display: flex;
  justify-content: space-between;
}

.model-hidden {
  display: none;
}

.ivu-modal {
  width: 1000px;
}
</style>
